import { render, staticRenderFns } from "./ExportWitnessTime.vue?vue&type=template&id=12706a03&"
import script from "./ExportWitnessTime.vue?vue&type=script&lang=js&"
export * from "./ExportWitnessTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports